import {useEffect, useMemo} from 'react';
import {CardEnvelopeTemplatePosition} from '~/common/FabricInvitation/EventCreateDesign/components/CardEnvelopeTemplate/CardEnvelopeTemplate';
import {EnvelopeEditorMobile} from '~/common/FabricInvitation/EventCreateDesign/components/Envelope/Mobile/EnvelopeEditorMobile';
import {
  type EnvelopeProps,
  useEnvelopeContext,
} from '~/common/FabricInvitation/EventCreateDesign/contexts/EnvelopeContext';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';
import {EnvelopeEditor} from './EnvelopeEditor';

export const EnvelopeContainer: React.FC = () => {
  const {showEnvelopeFront, setEnvelopeProps, setCardProps, setPosition} = useEnvelopeContext();
  const isLargishAndUp = useIsLargishAndUp();

  const envelopeProps: EnvelopeProps = useMemo(
    () =>
      showEnvelopeFront
        ? {
            showStamp: true,
            canvas: true,
            showStickers: true,
            type: 'image',
            message: "Guest's name will go here",
          }
        : {
            showLiner: true,
            type: 'blank',
          },
    [showEnvelopeFront]
  );

  useEffect(() => {
    setEnvelopeProps(envelopeProps);
    setCardProps({});
    setPosition(CardEnvelopeTemplatePosition.IN_FRONT_OF_CARD);
  }, [envelopeProps, setEnvelopeProps, setCardProps, setPosition]);

  return isLargishAndUp ? <EnvelopeEditor /> : <EnvelopeEditorMobile />;
};
